import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp"
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined"
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined"
import ListItemIcon from "@mui/material/ListItemIcon"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import { useState } from "react"
import { useSelector } from "react-redux"
import { Link as RouterLink } from "react-router-dom"

import Row from "../../../common/components/Row"
import UserAvatar from "../../../common/components/UserAvatar"
import { selectSafeLengthFullName } from "../../users/reducer"
import { SETTINGS_TABS, createSettingsTabURL } from "../settings/settingsTabs"
import { AvatarButton, LinkTypography } from "./sidebarStyles"

export const PROFILE_MENU_URL = createSettingsTabURL(SETTINGS_TABS.profile)

/** Avatar + name button; opens "My profile" / "Log out". */
export default function SidebarProfileMenu({ extended, onNavigate, onLogout }) {
  const [anchorElem, setAnchorElem] = useState(null)
  const userFullName = useSelector(selectSafeLengthFullName)
  const open = Boolean(anchorElem)

  function closeMenu() {
    setAnchorElem(null)
  }

  function handleMyProfileClicked() {
    closeMenu()
    onNavigate?.()
  }

  function handleLogOutClicked() {
    closeMenu()
    onLogout()
  }

  return (
    <>
      <AvatarButton
        component="button"
        type="button"
        extended={extended}
        onClick={(event) => setAnchorElem(event.currentTarget)}
        aria-label="Open profile menu"
        aria-haspopup="menu"
        aria-expanded={open ? "true" : undefined}
        title={userFullName}
      >
        <UserAvatar width={"30px"} fontSize={"12px"} />
        {extended ? (
          <Row
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              minWidth: 0,
            }}
          >
            <LinkTypography extended={extended}>{userFullName}</LinkTypography>
            <KeyboardArrowUpIcon sx={{ fill: "white" }} />
          </Row>
        ) : null}
      </AvatarButton>
      <Menu
        anchorEl={anchorElem}
        open={open}
        onClose={closeMenu}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "bottom", horizontal: "left" }}
        slotProps={{ paper: { sx: { minWidth: 180 } } }}
      >
        <MenuItem
          component={RouterLink}
          to={PROFILE_MENU_URL}
          onClick={handleMyProfileClicked}
        >
          <ListItemIcon>
            <PersonOutlinedIcon fontSize="small" />
          </ListItemIcon>
          My profile
        </MenuItem>
        <MenuItem onClick={handleLogOutClicked}>
          <ListItemIcon>
            <LogoutOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Log out
        </MenuItem>
      </Menu>
    </>
  )
}
